import { render, staticRenderFns } from "./AppTableHeadCellSort.vue?vue&type=template&id=11c4e43a&scoped=true&"
import script from "./AppTableHeadCellSort.vue?vue&type=script&lang=js&"
export * from "./AppTableHeadCellSort.vue?vue&type=script&lang=js&"
import style0 from "./AppTableHeadCellSort.vue?vue&type=style&index=0&id=11c4e43a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c4e43a",
  null
  
)

export default component.exports